function updateVerifiedBuyerAndAppendBadge(delay = 5000) {
  setTimeout(() => {
  const elements = document.querySelectorAll('.jdgm-rev.jdgm-divider-top.jdgm--done-setup.jdgm--leex-done-setup');
  elements.forEach((element) => {
    if (element.getAttribute('data-verified-buyer') === 'false') {
      element.setAttribute('data-verified-buyer', 'true');
      const authorWrapper = element.querySelector('.jdgm-rev__author-wrapper');
      
      if (authorWrapper) {
        const badgeWrapper = document.createElement('span');
        badgeWrapper.className = 'jdgm-rev__buyer-badge-wrapper';
        const badge = document.createElement('span');
        badge.className = 'jdgm-rev__buyer-badge';
        badgeWrapper.appendChild(badge);
        authorWrapper.appendChild(badgeWrapper);
      }
    }
  });

  // const loadMoreButton = document.querySelector('.jdgm-btn.jdgm-btn--solid.jdgm-paginate__load-more');

  // if (loadMoreButton) {
  //   loadMoreButton.addEventListener('click', (event) => {
  //     updateVerifiedBuyerAndAppendBadge(1000)
  //   });
    
  //   } else {
      
  //   }

    
  }, delay); 
}

document.addEventListener('click', (event) => {
  const loadMoreButton = event.target.closest('.jdgm-btn.jdgm-btn--solid.jdgm-paginate__load-more');
  if (loadMoreButton) {
    updateVerifiedBuyerAndAppendBadge(1000);
  }
});

updateVerifiedBuyerAndAppendBadge();
  
$('#open-sustainability-features').click(function() {
      $('#sustainability-features').css('display', 'block');
      $('.sustainability-features-copy').html($(this).find('[sustainability-features]').html());
      $('body').css('overflow', 'hidden');
});

$('.sustainability-features-close , #sustainability-features').click(function() {
    $('#sustainability-features').css('display', 'none');
     $('body').css('overflow', '');
});

$('.sustainability-features-modal-content').click(function(event) {
    event.stopPropagation();
});